export function normalizeMimeType({
  mimeTypeStr,
}: {
  mimeTypeStr?: string | null;
}): string | undefined {
  if (!mimeTypeStr) return undefined;
  const base = String(mimeTypeStr).toLowerCase().split(";")[0].trim();
  if (!base) return undefined;

  const aliasToCanonical: Record<string, string> = {
    "audio/x-wav": "audio/wav",
    "audio/wave": "audio/wav",
    "audio/x-m4a": "audio/mp4",
    "audio/m4a": "audio/mp4",
    "audio/x-mpeg": "audio/mpeg",
  };

  return aliasToCanonical[base] ?? base;
}

export function getFileExtensionFromMimeType({ mimeTypeStr }: { mimeTypeStr: string }): string {
  const normalized = normalizeMimeType({ mimeTypeStr }) ?? mimeTypeStr.toLowerCase();
  const mimeToExtension: Record<string, string> = {
    "audio/webm": "webm",
    "audio/mp4": "mp4",
    "audio/wav": "wav",
    "audio/ogg": "ogg",
    "audio/mpeg": "mp3",
    "audio/aac": "aac",
  };
  return mimeToExtension[normalized] || "webm";
}
